 import { message, PageHeader, Popconfirm, Table, Tag, Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { TableItemDinamico, dineroDisabledMask, ButtonItem, ModalItem, SegmentedItem, NotificacionMovimientosInventario } from "../../../Components/Items";
import moment from "moment";
import 'moment/locale/es'
import { connect } from "react-redux";
import { CloseCircleOutlined, EditOutlined, FileExcelOutlined, InboxOutlined, MailOutlined, /*EnvironmentOutlined, EyeOutlined */ } from "@ant-design/icons";
import { IconArrowsSplit2 } from "../../../Icons/Icons";
import ModalEditarDatosFactura from "../../../Components/ModalEditarDatosFactura";
import ModalMandarCorreoFacturas from "../FacturasCajaChica/ModalMandarCorreoFacturas/ModalMandarCorreoFacturas";
import ModalRutaAlmacenaje from "../../../Components/ModalRutaAlmacenaje";
import ModalUbicacionesConfirmadas from "../../../Components/ModalUbicacionesConfirmadas";
import ElegirLotes from "../LotesCaducidades/ElegirLotes/ElegirLotes";
moment.locale('es')

class FacturasSinOrdenDeCompra extends Component {
  tableRef = null; 
  state = {
    todasFacturasSinOrdenDeCompra: [],
    loading: false,
    valor: 5,
    totalRecords: 0, 
    modalCorreo: false,
    modalCorreoId: null,
    modalEditarDatos: false,
    modalEditarDatosId: null,
    facturaIdsConPendiente: new Set(),
    modalRutaAlmacenajeVisible: false,
    modalRutaAlmacenajeFacturaId: null,
    modalUbicacionesConfirmadasVisible: false,
    modalUbicacionesConfirmadasFacturaId: null,
    confirmacionVisible: false,
    confirmacionLoading: false,
    confirmacionData: null,
    facturaIdAConfirmar: null,
    loteSeleccionVisible: false,
    loteSeleccionActual: null,
    loteSeleccionCola: [],
    seleccionesLotesAcumuladas: [],
  }
  

  consultarFacturasSinOrdenDeCompra ( params = {}){
    this.setState({loading: true}); 
    const body = {
      empresaId: this.props.empresaId,
      ...params,
    };

    axios
      .post(
        "facturassinordendecompra/selectFacturas",
        body,
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });
        
        let data = [];
        let total = 0;

        // Soporte para respuesta nueva { success: 2, data: [], totalRecords: N }
        if (res.data.success === 2) {
          data = res.data.data;
          total = res.data.totalRecords;
        } else if (Array.isArray(res.data)) {
          // Soporte legacy
          data = res.data;
          total = res.data.length;
        } else if (res.data.status === 404) {
          data = [];
          total = 0;
        }

        this.setState({
          totalRecords: total,
          todasFacturasSinOrdenDeCompra: data.map((value) => {
            return {
              ...value,
              // Usamos proveedorNombre del backend si viene, sino lo armamos
              proveedorNombre: value.proveedorNombre
                ? value.proveedorNombre
                : value.proveedor.nombre
                ? value.proveedor.nombre +
                  " " +
                  value.proveedor.apellidoPaterno +
                  " " +
                  value.proveedor.apellidoMaterno
                : value.proveedor.razonSocial,
              accion: {
                _id: value._id,
                estado: value.estado,
                xml: value.xml,
                estadoPago: value.estadoPago,
                prorrateo: value.prorrateo,
              },
            };
          }),
        });
        this.consultarRutaAlmacenajePendiente(data.map((value) => value._id));
      })
      .catch((err) => {
        console.error(err);
        this.setState({ loading: false, todasFacturasSinOrdenDeCompra: [], totalRecords: 0 });
      });

  }

  consultarRutaAlmacenajePendiente(facturaIds) {
    if (!Array.isArray(facturaIds) || facturaIds.length === 0) {
      this.setState({ facturaIdsConPendiente: new Set() });
      return;
    }
    axios
      .post(
        "facturassinordendecompra/facturasConRutaAlmacenajePendiente",
        { empresaId: this.props.empresaId, facturaIds },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({ facturaIdsConPendiente: new Set(res.data.facturaIdsConPendiente) });
        }
      })
      .catch((err) => console.error("Error al consultar rutas de almacenaje pendientes:", err));
  }

  cerrarModalRutaAlmacenaje() {
    this.setState({ modalRutaAlmacenajeVisible: false, modalRutaAlmacenajeFacturaId: null });
    this.consultarRutaAlmacenajePendiente(this.state.todasFacturasSinOrdenDeCompra.map((value) => value._id));
  }

  agregarFacturaSinOrdenDeCompra() {
    this.props.history.push('/panel/agregarFacturaSinOrdenDeCompra')
  }
  importarFacturasXmlMasivo() {
    this.props.history.push('/panel/importarFacturasXmlMasivo')
  }
  importarGastosXml() {
    this.props.history.push('/panel/importarGastosXml')
  }
  recibirInsumosFactura(id) {
    this.props.history.push('/panel/recibirInsumosFactura', { id })
  }
  cancelarFactura(value, confirmarDescuentoInventarioGeneral = false) {
    if (confirmarDescuentoInventarioGeneral) {
      this.setState({ confirmacionLoading: true });
    }
    axios
      .post(
        "facturassinordendecompra/cancelarFactura",
        {
          facturaId: value,
          empresaId: this.props.empresaId,
          ...(confirmarDescuentoInventarioGeneral ? { confirmarDescuentoInventarioGeneral: true } : {}),
          ...(this.state.seleccionesLotesAcumuladas.length > 0
            ? { seleccionesLotes: this.state.seleccionesLotesAcumuladas }
            : {}),
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Factura cancelada");
          NotificacionMovimientosInventario(res.data.movimientosIds);
          this.setState({
            confirmacionLoading: false,
            confirmacionVisible: false,
            confirmacionData: null,
            facturaIdAConfirmar: null,
            loteSeleccionVisible: false,
            loteSeleccionActual: null,
            loteSeleccionCola: [],
            seleccionesLotesAcumuladas: [],
          });
        } else if (res.data.success === 4) {
          const cola = res.data.insumosLotes || [];
          this.setState({
            confirmacionLoading: false,
            facturaIdAConfirmar: value,
            loteSeleccionActual: cola[0] || null,
            loteSeleccionCola: cola.slice(1),
            loteSeleccionVisible: cola.length > 0,
          });
        } else if (res.data.success === 3) {
          this.setState({
            confirmacionLoading: false,
            confirmacionVisible: true,
            confirmacionData: {
              message: res.data.message,
              detalle: res.data.detalle || [],
            },
            facturaIdAConfirmar: value,
          });
        } else if (res.data.success === 1) {
          this.setState({ confirmacionLoading: false });
          message.warn(res.data.message);
        } else {
          this.setState({ confirmacionLoading: false });
          message.error("Sucedio un error y no se pudo cancelar");
        }
        if (this.tableRef) {
          this.tableRef.updateExternalFilters({ valor: this.state.valor });
        }
      });
  }

  confirmarCancelacionConDescuentoInventario = () => {
    if (!this.state.facturaIdAConfirmar) return;
    this.cancelarFactura(this.state.facturaIdAConfirmar, true);
  };

  onElegirLotesCerrado = (lotesFiltrados) => {
    const { loteSeleccionActual, loteSeleccionCola, facturaIdAConfirmar } = this.state;
    if (!lotesFiltrados || lotesFiltrados.length === 0) {
      this.setState({
        loteSeleccionVisible: false,
        loteSeleccionActual: null,
        loteSeleccionCola: [],
        seleccionesLotesAcumuladas: [],
        facturaIdAConfirmar: null,
      });
      return;
    }
    const nuevaSeleccion = {
      entradaOriginalId: loteSeleccionActual.entradaOriginalId,
      lotes: lotesFiltrados.map((l) => ({ entradaId: l.entradaId, cantidadRequerida: l.cantidadRequerida })),
    };
    this.setState(
      (prevState) => ({
        seleccionesLotesAcumuladas: [...prevState.seleccionesLotesAcumuladas, nuevaSeleccion],
        loteSeleccionActual: loteSeleccionCola[0] || null,
        loteSeleccionCola: loteSeleccionCola.slice(1),
        loteSeleccionVisible: loteSeleccionCola.length > 0,
      }),
      () => {
        if (loteSeleccionCola.length === 0) {
          this.cancelarFactura(facturaIdAConfirmar);
        }
      }
    );
  };

  cerrarConfirmacionCancelacion = () => {
    this.setState({
      confirmacionVisible: false,
      confirmacionData: null,
      facturaIdAConfirmar: null,
    });
  };
  descargarXml(value) {
    axios
      .post(
        "facturas/descargarXml",
        { facturaId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        var xmltext = res.data.string;

        var filename = "file.xml";
        var pom = document.createElement("a");
        var bb = new Blob([xmltext], { type: "text/plain" });

        pom.setAttribute("href", window.URL.createObjectURL(bb));
        pom.setAttribute("download", filename);

        pom.dataset.downloadurl = [
          "text/plain",
          pom.download,
          pom.href,
        ].join(":");
        pom.draggable = true;
        pom.classList.add("dragout");

        pom.click();
      });
  }

  abrirMandarCorreoFactura(id) {
    this.setState({
      modalCorreo: true,
      modalCorreoId: id,
    });
  }

  cerrarMandarCorreoFactura() {
    this.setState({
      modalCorreo: false,
      modalCorreoId: null,
    });
  }

  abrirEditarDatosFactura(id) {
    this.setState({ modalEditarDatos: true, modalEditarDatosId: id });
  }

  cerrarEditarDatosFactura(recargar = false) {
    this.setState({ modalEditarDatos: false, modalEditarDatosId: null });
    if (recargar && this.tableRef) {
      this.tableRef.updateExternalFilters({ valor: this.state.valor });
    }
  }
  render() {
    const {todasFacturasSinOrdenDeCompra, totalRecords, loading} = this.state; 

    const columns = [
      {
        title: "Núm",
        dataIndex: "numeroFactura",
        key: "numeroFactura",
        sorter: (a, b) => {
          if (a.codigoFactura < b.codigoFactura) {
            return -1;
          }
          if (a.codigoFactura > b.codigoFactura) {
            return 1;
          }
          return 0;
        },
        buscar: 'numeroFactura',
        width: '8%',
        ellipsis: true,
      },
      {
        title: "Codigo",
        dataIndex: "codigoFactura",
        key: "codigoFactura",
        // sorter: (a, b) => {
        //   if (a.codigoFactura < b.codigoFactura) {
        //     return -1;
        //   }
        //   if (a.codigoFactura > b.codigoFactura) {
        //     return 1;
        //   }
        //   return 0;
        // },
        render: (value) => value,
        buscar: 'codigoFactura',
        width: '8%',
        ellipsis: true,
      },
      {
        title: "Proyecto",
        dataIndex: "proyecto",
        key: "proyecto",
        sorter: (a, b) => {
          if (a.proyecto.nombre < b.proyecto.nombre) {
            return -1;
          }
          if (a.proyecto.nombre > b.proyecto.nombre) {
            return 1;
          }
          return 0;
        },
        render: (value) => value.nombre,
        width: '8%',
        ellipsis: true,
      },
      {
        title: "Proveedor",
        dataIndex: "proveedorNombre",
        key: "proveedorNombre",
        sorter: (a, b) => {
          if (a.proveedorNombre < b.proveedorNombre) {
            return -1;
          }
          if (a.proveedorNombre > b.proveedorNombre) {
            return 1;
          }
          return 0;
        },
        buscar: 'proveedorNombre',
        width: '30%',
        ellipsis: true,
      },
      {
        title: "Fecha",
        dataIndex: "fechaFactura",
        key: "fechaFactura",
        defaultSortOrder: 'descend',
        sorter: (a, b) => {
          if (moment(a.fechaFactura) < moment(b.fechaFactura)) {
            return -1;
          }
          if (moment(a.fechaFactura) > moment(b.fechaFactura)) {
            return 1;
          }
          return 0;
        },
        render: (value) => moment(value).locale('es').format('L'),
        width: '8%',
        ellipsis: true,
        align: 'center',
      },
      {
        title: "Recepción",
        dataIndex: "fechaRecepcion",
        key: "fechaRecepcion",
        defaultSortOrder: 'descend',
        render: (value, record) => moment(value || record.createdAt).locale('es').format('L'),
        width: '7%',
        ellipsis: true,
        align: 'center',
      },
      {
        title: 'Subtotal / Total',
        dataIndex: 'subtotal',
        key: 'subtotal',
        sorter: (a, b) => {
          if (a.subtotal < b.subtotal) {
            return -1;
          }
          if (a.subtotal > b.subtotal) {
            return 1;
          }
          return 0;
        },
        render: (_, record) => (
          <div style={{ textAlign: "right" }}>
            <div style={{ fontSize: "12px", color: "#666", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
              <span>{dineroDisabledMask(record.subtotal)}</span>
              {record.moneda?.abreviacion && <span style={{ fontSize: "12px", color: "#666" }}>{record.moneda.abreviacion }</span>}
            </div>
            <div style={{ fontSize: "12px", fontWeight: "bold", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
              <span>{dineroDisabledMask(record.totalPagar)}</span>
              {record.moneda?.abreviacion && <span style={{ fontSize: "12px", color: "#666" }}>{record.moneda.abreviacion}</span>}
            </div>
          </div>
        ),
        buscar: 'totalPagar',
        width: '12%',
        ellipsis: true,
        align: 'right',
      },
      {
        title: 'Total',
        dataIndex: 'totalPagar',
        key: 'totalPagar',
        sorter: (a, b) => {
          if (a.totalPagar < b.totalPagar) {
            return -1;
          }
          if (a.totalPagar > b.totalPagar) {
            return 1;
          }
          return 0;
        },
        buscar: 'totalPagar',
        responsive: [],
        width: 0,
      },
      {
        title: 'Estado',
        dataIndex: 'estado',
        key: 'estado',
        render: (value, record, index) => {
          const tags = [];
          if (value === 0) {
            tags.push(<Tag key={index.toString()} color='red' className="square-tag">Cancelada</Tag>)
          }
          if (value === 1) {
            tags.push(<Tag key={index.toString()} color='blue' className="square-tag">Sin recibir</Tag>)
          }
          if (value === 2) {
            tags.push(<Tag key={index.toString()} color='orange' className="square-tag" style={{ fontSize: 10 }}>Recibido parcialmente</Tag>)
          }
          if (value === 3) {
            tags.push(<Tag key={index.toString()} color='green' className="square-tag">Recibido</Tag>)
          }
          if (record.prorrateoDesCostos) {
            tags.push(<Tag key={`prorrateo-${record._id}`} color='geekblue' className="square-tag">Prorrateo</Tag>)
          }
          if (record.cargaHistorica) {
            tags.push(
              <Tooltip key={`historico-${record._id}`} title="Factura cargada como histórico en la implementación (sin contabilidad)">
                <Tag color='default' className="square-tag">Histórico</Tag>
              </Tooltip>
            )
          }
          return <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>{tags}</div>
        },
        width: '13%',
        ellipsis: true,
      },
      ...(this.props.mostrarComplementoPagoFacturas ? [{
        title: 'Complemento',
        dataIndex: 'tieneComplementoPago',
        key: 'tieneComplementoPago',
        align: 'center',
        width: '8%',
        render: (value) => value
          ? <Tag color="green" className="square-tag3">Con Rep</Tag>
          : <Tag color="gold" className="square-tag3">Sin Rep</Tag>,
      }] : []),
      {
        title: 'Acción',
        dataIndex: 'accion',
        key: 'accion',
        align: 'center',
        width: '10%',
        onHeaderCell: () => ({
          style: { textAlign: 'center', padding: '4px' }
        }),
        onCell: () => ({
          className: "acciones-sin-hover",
          style: { textAlign: 'center', padding: '4px' }
        }),
        render: (value, record, index) => {
          if (value.estado === 0) return null;

          let buttons = [];

          buttons.push(
          <Tooltip title="Mandar correo" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
            <ButtonItem
              key={`correo-${index}`}
              type="default"
              size="small"
              azul
              icon={<MailOutlined />}
              onClick={() => this.abrirMandarCorreoFactura(value._id)}
            />
          </Tooltip>)

          const puedeDescargarXml = value.estado !== 0 && value.xml;
          if (puedeDescargarXml) {
            buttons.push(
              <Tooltip title="Descargar XML" key={`xml-${index}`} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <FileExcelOutlined onClick={() => this.descargarXml(value._id)} style={{ cursor: 'pointer', fontSize: '16px' }} />
              </Tooltip>
            );
          }

          if (this.props.permisoEditarFacturaSinOrdenDeCompra) {
            buttons.push(
              <Tooltip title="Editar datos" key={`editar-${index}`} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  type="default"
                  size="small"
                  naranja
                  icon={<EditOutlined />}
                  onClick={() => this.abrirEditarDatosFactura(value._id)}
                />
              </Tooltip>
            );
          }

          const puedeRecibir = (value.estado === 1 || value.estado === 2) && this.props.permisoRecibirInsumosFacturaSinOrdenDeCompra;
          buttons.push(
            <Tooltip title={puedeRecibir ? "Recibir Insumos" : "No disponible"} key={`recibir-${index}`} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              <ButtonItem
                azul
                type='default'
                size='small'
                onClick={() => puedeRecibir && this.recibirInsumosFactura(value._id)}
                icon={<InboxOutlined />}
                disabled={!puedeRecibir}
              >
              </ButtonItem>
            </Tooltip>
          );

          // const tieneRutaAlmacenajePendiente = this.state.facturaIdsConPendiente?.has(value._id.toString());
          // if (tieneRutaAlmacenajePendiente && this.props.permisoRecibirInsumosFacturaSinOrdenDeCompra && this.props.moduloWms) {
          //   buttons.push(
          //     <Tooltip title="Ruta de almacenaje" key={`ruta-almacenaje-tip-${index}`} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
          //       <ButtonItem
          //         key={`ruta-almacenaje-${index}`}
          //         type="default"
          //         size="small"
          //         naranja
          //         icon={<EnvironmentOutlined />}
          //         onClick={() => this.setState({ modalRutaAlmacenajeFacturaId: value._id, modalRutaAlmacenajeVisible: true })}
          //       >
          //       </ButtonItem>
          //     </Tooltip>
          //   );
          // }

          // const yaRecibioAlgo = value.estado === 2 || value.estado === 3;
          // if (yaRecibioAlgo && this.props.permisoRecibirInsumosFacturaSinOrdenDeCompra && this.props.moduloWms) {
          //   buttons.push(
          //     <Tooltip title="Ver ubicaciones" key={`ver-ubicaciones-tip-${index}`} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
          //       <ButtonItem
          //         key={`ver-ubicaciones-${index}`}
          //         type="default"
          //         size="small"
          //         turquesa
          //         icon={<EyeOutlined />}
          //         onClick={() => this.setState({ modalUbicacionesConfirmadasFacturaId: value._id, modalUbicacionesConfirmadasVisible: true })}
          //       >
          //       </ButtonItem>
          //     </Tooltip>
          //   );
          // }

          if (value.estado === 3 && this.props.prorrateoDesCostos && !value.prorrateo) {
            buttons.push(
              <Tooltip title="Prorrateo" key={`prorrateo-${index}`} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  type="default"
                  size="small"
                  morado
                  icon={<IconArrowsSplit2 marginRight={0} />}
                  onClick={() => this.props.history.push('/panel/prorratearFacturaSinOrdenDeCompra', { id: value._id })}
                />
              </Tooltip>
            );
          }

          // Las cargas historicas (CXP Implementacion en modo solo historico) nacen con
          // estadoPago 3 sin poliza ni pagos detras, asi que se pueden cancelar para
          // poder deshacer una importacion equivocada.
          const puedeCancelar = value.estado !== 0 && (value.estadoPago === 0 || value.cargaHistorica) && this.props.permisoCancelarFacturaSinOrdenDeCompra;
          buttons.push(
            <Popconfirm
              key={`cancelar-${index}`}
              title="Seguro que quieres cancelar esta factura"
              onConfirm={() => this.cancelarFactura(value._id)}
              okText="Si"
              cancelText="No"
              disabled={!puedeCancelar}
            >
              <Tooltip title={puedeCancelar ? "Cancelar" : "No se puede cancelar"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  type='default'
                  size='small'
                  rojo
                  icon={<CloseCircleOutlined />}
                  disabled={!puedeCancelar}
                >
                </ButtonItem>
              </Tooltip>
            </Popconfirm>
          );

          return <div className="acciones-container">{buttons}</div>;
        },
      }
    ]
    return (
      <>
        <PageHeader
          title="Facturas sin Orden de Compra"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <>
              {window.innerWidth > 1000 &&
                <SegmentedItem
                  options={[
                    { label: "Sin Recibir", value: 1 },
                    { label: "Recibido Parcialmente", value: 2 },
                    { label: "Recibido", value: 3 },
                    { label: "Cancelada", value: 4 },
                    { label: "Todos", value: 5 },
                  ]}
                  onChange={(value) => {
                    if (this.tableRef) {
                      this.tableRef.updateExternalFilters({ valor: value });
                    }
                    this.setState({ valor: value });
                  }}
                  value={this.state.valor}
                />
              }
              {/* {this.props.permisoAgregarFacturaSinOrdenDeCompra &&
                <ButtonItem
                  key="importarFacturasXmlMasivo"
                  bondi
                  onClick={this.importarFacturasXmlMasivo.bind(this)}
                  style={{ marginRight: 8 }}
                >
                  Importar XMLs
                </ButtonItem>} */}
              {/* Captura rapida: los impuestos salen del XML y solo se elige el gasto */}
              {this.props.permisoAgregarFacturaSinOrdenDeCompra &&
                <ButtonItem
                  key="importarGastosXml"
                  bondi
                  onClick={this.importarGastosXml.bind(this)}
                  style={{ marginRight: 8 }}
                >
                  Importar Gastos XML
                </ButtonItem>}
              {this.props.permisoAgregarFacturaSinOrdenDeCompra &&
                <ButtonItem
                  type="primary"
                  key="agregarFacturaSinOrdenDeCompra"
                  olivo
                  onClick={this.agregarFacturaSinOrdenDeCompra.bind(this)}
                   className="botonAgregar"
                >
                  Agregar Factura
                </ButtonItem>}
            </>
          }
        />
        <TableItemDinamico
          ref={(ref) => (this.tableRef = ref)} 
          onRef={(ref) => (this.tableRef = ref)}
          totalRecords={totalRecords}
          loading={loading}
          anadirValorFiltro={this.state.valor}
          onFetchData={this.consultarFacturasSinOrdenDeCompra.bind(this)}
          size="small"
          dataSource={todasFacturasSinOrdenDeCompra}
          columns={columns}
          pagination={false}
          setTextoFiltro={(textoFiltro) => this.setState({ textoFiltro })} 
          filterStorageKey={"facturasSinOCFiltros" + this.props.empresaId}
          setValor={(valor) => this.setState({ valor })}
          valorDefault={5}
          
          // Doble click
          onRow={(record, rowIndex) => {
            return {
              onDoubleClick: (event) => {
                this.props.history.push("/panel/verFacturaSinOrdenDeCompra", {
                  id: record._id,
                });
              },
            };
          }}
          locale={{ emptyText: "No se encontraron facturas" }}
        />
        <ModalMandarCorreoFacturas
          visible={this.state.modalCorreo}
          id={this.state.modalCorreoId}
          cerrarModalMandarCorreoFacturas={this.cerrarMandarCorreoFactura.bind(
            this,
          )}
          tipoFactura ="Sin Orden De Compra"
        />
        <ModalRutaAlmacenaje
          visible={this.state.modalRutaAlmacenajeVisible}
          onClose={this.cerrarModalRutaAlmacenaje.bind(this)}
          empresaId={this.props.empresaId}
          headersToken={this.props.headersToken}
          documentoOrigenId={this.state.modalRutaAlmacenajeFacturaId}
          documentoOrigenTipo="FacturaSinOrdenDeCompra"
        />
        <ModalUbicacionesConfirmadas
          visible={this.state.modalUbicacionesConfirmadasVisible}
          onClose={() => this.setState({ modalUbicacionesConfirmadasVisible: false, modalUbicacionesConfirmadasFacturaId: null })}
          empresaId={this.props.empresaId}
          headersToken={this.props.headersToken}
          documentoOrigenId={this.state.modalUbicacionesConfirmadasFacturaId}
          documentoOrigenTipo="FacturaSinOrdenDeCompra"
        />
        <ModalItem
          title="Confirmar cancelación de factura"
          visible={this.state.confirmacionVisible}
          spinning={this.state.confirmacionLoading}
          onCancel={this.cerrarConfirmacionCancelacion}
          onOk={this.confirmarCancelacionConDescuentoInventario}
          okText="Continuar"
          cancelText="Cancelar"
          footer
          paddingTop
          width={window.innerWidth > 1000 ? "55%" : "95%"}
        >
          {this.state.confirmacionData && (
            <>
              <p style={{ marginTop: 10 }}>{this.state.confirmacionData.message}</p>
              {this.state.confirmacionData.detalle.length > 0 && (
                <Table
                  size="small"
                  pagination={false}
                  rowKey={(record, index) => `${record.insumoId || ""}-${index}`}
                  dataSource={this.state.confirmacionData.detalle}
                  columns={[
                    {
                      title: "Insumo",
                      key: "insumo",
                      render: (record) => `${record.clave || ""} - ${record.descripcion || ""}`,
                    },
                    {
                      title: "Cantidad",
                      dataIndex: "cantidad",
                      key: "cantidad",
                      align: "right",
                    },
                    {
                      title: "Costo original",
                      dataIndex: "costoOriginal",
                      key: "costoOriginal",
                      align: "right",
                      render: (costo) => dineroDisabledMask(costo || 0),
                    },
                    {
                      title: "Costo actual",
                      dataIndex: "costoProyectado",
                      key: "costoProyectado",
                      align: "right",
                      render: (costo) => dineroDisabledMask(costo || 0),
                    },
                  ]}
                  style={{ marginBottom: 10 }}
                />
              )}
            </>
          )}
        </ModalItem>
        <ElegirLotes
          visible={this.state.loteSeleccionVisible}
          insumoId={this.state.loteSeleccionActual?.insumoId}
          proyectoId={this.state.loteSeleccionActual?.proyectoId}
          cantidad={this.state.loteSeleccionActual?.cantidad}
          cerrarElegirLotes={this.onElegirLotesCerrado}
        />
        <ModalEditarDatosFactura
          visible={this.state.modalEditarDatos}
          facturaId={this.state.modalEditarDatosId}
          onCancel={() => this.cerrarEditarDatosFactura(false)}
          onSuccess={() => this.cerrarEditarDatosFactura(true)}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    permisoAgregarFacturaSinOrdenDeCompra: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615cbf0af30e81b54183cf60")?.activado,
    permisoCancelarFacturaSinOrdenDeCompra: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615cbf87f30e81b54183cf61")?.activado,
    permisoRecibirInsumosFacturaSinOrdenDeCompra: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615cc149f30e81b54183cf64")?.activado,
    permisoEditarFacturaSinOrdenDeCompra: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "6a94a0881aa752bd87014589")?.activado,
    prorrateoDesCostos: state.empresa.prorrateoDesCostos,
    moduloWms: state.empresa.moduloWms,
    mostrarComplementoPagoFacturas: state.empresa.mostrarComplementoPagoFacturas,
  };
};

export default connect(mapStateToProps)(FacturasSinOrdenDeCompra);